function init() {
  const smallScreen                 = (window.innerWidth <= 767) ? true : false;
  const headerElement               = document.querySelector('.header');
  const mainElement                 = document.querySelector('.main');
  const mobileMainnavgationElement  = document.querySelector('.mobilemainnavigation');
  const mobilePropertySearchElement = document.querySelector('.mobilepropertysearch');
  const mobilePropertyFilterElement = document.querySelector('.mobilepropertyfilter');
  const isSearchPage = mobilePropertySearchElement ? mobilePropertySearchElement.classList.contains('mobilepropertysearch--issearchpage') : false;

  if (headerElement && mainElement) {

    if (window.pageYOffset > 0) {
      if (mobilePropertySearchElement) {
        if (smallScreen && isSearchPage) {
          headerElement.classList.add('header--sticky-issearchpage');
        } else {
          headerElement.classList.add('header--sticky');
        }
      } else {
        headerElement.classList.add('header--sticky');
      }
    } else {
      headerElement.classList.remove('header--sticky', 'header--sticky--issearchpage');
    }

    if (smallScreen) {
      headerElement.classList.add('header--mobile');
      if (mobileMainnavgationElement) {
        if (!mobileMainnavgationElement.classList.contains('mobilemainnavigation--open')) {
          if (isSearchPage && mobilePropertySearchElement && mobilePropertyFilterElement) {
            mainElement.style.marginTop = headerElement.offsetHeight + mobilePropertySearchElement.offsetHeight + mobilePropertyFilterElement.offsetHeight + 'px';
          } else {
            mainElement.style.marginTop = headerElement.offsetHeight + 'px';
          }
        }
      }
    } else {
      headerElement.classList.remove('header--mobile');
      mainElement.style.marginTop = '0px';
    }

  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Header.js